import Instructions from '../instructions';


export default new Instructions();

export {Instructions};